<template>
  <div id="containt">
    <div class="detail-wrap" style="margin-top: 8px;">
      <el-form ref="editForm" :model="formData">
        <div class="d-header clearfix">
          <div class="fl">
            <i class="el-icon-info" />
            参数配置信息
          </div>
          <div class="fr">
            <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
          </div>
        </div>
        <div>

          <!-- 品牌信息 -->
          <div class="d-cont edit-mce-box">
            <div class="d-item">
              <div class="title first">
                <b>延保参数</b>
              </div>
              <table class="table-detail">
                <tbody>
                  <tr>

                    <th>
                      <em class="f-red">*</em>
                      可申请退保天数
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.backDates" clearable />
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      过退保期限后几小时开始分账
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.beyondHoursCreateBenefit" clearable />
                    </td>
                    <th>
                      审核金额开关
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.amountGate" clearable />
                    </td>
                    <th>
                      好评时赠送的延保月数
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.goodCommentGift" clearable />
                    </td>
                  </tr>
                <tr>
                  <th>
                    在线客服跳转地址
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.onLineUrl" clearable />
                  </td>
                  <th>
                    400电话
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.callCenterPhone" clearable />
                  </td>
                  <th>
                    组网上限
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.companyCustNetLimit" clearable />
                  </td>
                  <th>
                    评价小时限制
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.companyEvaluateMaxHours" clearable />
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="d-item" style="height:; ">
              <el-row>
                <el-col :span="11" style="margin-right: 20px;">
                  <div class="title first">
                    <b>微信参数</b>
                  </div>
                  <div>
                    <div class="headline">隐私协议:</div>

                    <!-- <quill-editor class="editor"
                                ref="myTextEditor"
                                v-model="formData.content"
                                :options="editorOption"
                                @blur="onEditorBlur($event)"
                                @focus="onEditorFocus($event)"
                                @ready="onEditorReady($event)"
                                @change="onEditorChange($event)">
                  </quill-editor> -->
                    <quill-editor class="editor" ref="myTextEditor" v-model="formData.privacyPolicy"
                      :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
                      @ready="onEditorReady($event)" @change="onEditorChange($event)">
                    </quill-editor>
                  </div>
                </el-col>
                <el-col :span="11" >
                  <div class="title first">
                    <b style="margin-left: 0px; visibility: hidden;">内容</b>
                  </div>
                  <div>
                    <div class="headline">用户协议:</div>
                    <quill-editor class="editor" ref="myTextEditor" v-model="formData.userPolicy" :options="editorOption"
                      @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)"
                      @change="onEditorChange($event)">
                    </quill-editor>
                  </div>
                </el-col>
              </el-row>
              <el-row  style="margin-top: 75px;">
                <el-col :span="11" style="margin-right: 20px;">
                  <div class="title first">
                    <!-- <b>微信参数</b> -->
                  </div>
                  <div>
                    <div class="headline">服务条款:</div>

                    <quill-editor class="editor" ref="myTextEditor" v-model="formData.servicePolicy"
                      :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
                      @ready="onEditorReady($event)" @change="onEditorChange($event)">
                    </quill-editor>
                  </div>
                </el-col>
                <el-col :span="11">
                  <div class="title first">
                    <!-- <b style="margin-left: 0px;">内容</b> -->
                  </div>
                  <div>
                    <div class="headline">扫码示例:</div>
                    <quill-editor class="editor" ref="myTextEditor" v-model="formData.scanTemp" :options="editorOption"
                      @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)"
                      @change="onEditorChange($event)">
                    </quill-editor>
                  </div>
                </el-col>
              </el-row>
              <el-row  style="margin-top: 75px;">
                <el-col :span="11" style="margin-right: 20px;">
                  <div class="title first">
                    <!-- <b>微信参数</b> -->
                  </div>
                  <div>
                    <div class="headline">保修卡说明:</div>

                    <quill-editor class="editor" ref="myTextEditor" v-model="formData.cardPolicy" :options="editorOption"
                      @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)"
                      @change="onEditorChange($event)">
                    </quill-editor>
                  </div>
                </el-col>
                <el-col :span="11">
                  <div class="title first">
                    <!-- <b style="margin-left: 0px;">内容</b> -->
                  </div>
                  <div>
                    <div class="headline">服务须知:</div>
                    <quill-editor class="editor" ref="myTextEditor" v-model="formData.serviceNotice" :options="editorOption"
                                  @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)"
                                  @change="onEditorChange($event)">
                    </quill-editor>
                  </div>
                </el-col>
              </el-row>
              <div style="height: 85px;"></div>
            </div>
            <div class="d-item">
              <div class="title first">
                <b>微信轮播图</b>
              </div>
              <div style="display: flex;flex-wrap: wrap;">
              <div class="carousel" style="margin-right: 2%;">
                <div>
                  <div style="display: flex;">
                    <div class="carousel_item">
                      <span>轮播图1标题:</span>
                      <el-input type="text" autocomplete="off" v-model="formData.banner1Title" clearable
                        style="width: 7vw;"></el-input>
                    </div>
                    <div class="carousel_item">
                      <span>跳转类型:</span>
                      <el-select v-model="formData.banner1SkipType" style="width:7vw">
                              <el-option label="无跳转" :value="0"/>
                              <el-option label="外部链接" :value="1"/>
                              <el-option label="小程序" :value="2"/>
                            </el-select>
                    </div>
                  </div>
                  <div class="carousel_item">
                    <span>跳转链接:</span>
                    <el-input type="text" autocomplete="off" v-model="formData.banner1SkipUrl" clearable
                      style="width: 20vw;"></el-input>
                  </div>
                  <div class="carousel_item">
                    <span>跳转参数:</span>
                    <el-input type="text" autocomplete="off" v-model="formData.banner1SkipParameter" clearable
                      style="width: 20vw;"></el-input>
                  </div>
                </div>

                <!-- <div style="height: 60px;width: 60px; background-color:aquamarine;"></div> -->
                  <!-- 图片 -->
                  <!-- <el-upload style="display:flex" :class="{hide_box: upload_btn1}"
                                     action="/admin/sys-file/upload"
                                     ref="upload" accept=".jpeg,.jpg,.png" :headers="headers"
                                     :on-remove="handleRemove1" list-type="picture-card" :file-list="picList1"
                                     :on-success="(res,file) => {handleSuccess1(res,file)}"
                                     :on-change="(files, fileList) => {handleChange(files, fileList)}">
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload> -->
                          <photoUpload :photo-url.sync="picList1"/>
              </div>
              <div class="carousel">
                <div>
                  <div style="display: flex;">
                    <div class="carousel_item">
                      <span>轮播图2标题:</span>
                      <el-input type="text" autocomplete="off" v-model="formData.banner2Title" clearable
                        style="width: 7vw;"></el-input>
                    </div>
                    <div class="carousel_item">
                      <span>跳转类型:</span>
                      <el-select v-model="formData.banner2SkipType" style="width:7vw">
                              <el-option label="无跳转" :value="0"/>
                              <el-option label="外部链接" :value="1"/>
                              <el-option label="小程序" :value="2"/>
                            </el-select>
                    </div>
                  </div>
                  <div class="carousel_item">
                    <span>跳转链接:</span>
                    <el-input type="text" autocomplete="off" v-model="formData.banner2SkipUrl" clearable
                      style="width: 20vw;"></el-input>
                  </div>
                  <div class="carousel_item">
                    <span>跳转参数:</span>
                    <el-input type="text" autocomplete="off" v-model="formData.banner2SkipParameter" clearable
                      style="width: 20vw;"></el-input>
                  </div>
                </div>

                <!-- <div style="height: 60px;width: 60px; background-color:aquamarine;"></div> -->
                  <!-- 图片 -->
                  <!-- <el-upload style="display:flex" :class="{hide_box: upload_btn1}"
                                     action="/admin/sys-file/upload"
                                     ref="upload" accept=".jpeg,.jpg,.png" :headers="headers"
                                     :on-remove="handleRemove2" list-type="picture-card" :file-list="picList2"
                                     :on-success="(res,file) => {handleSuccess2(res,file)}"
                                     :on-change="(files, fileList) => {handleChange(files, fileList)}">
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload> -->
                          <photoUpload :photo-url.sync="picList2"/>

              </div>
              <div class="carousel" style="margin-right: 2%;">
                <div>
                  <div style="display: flex;">
                    <div class="carousel_item">
                      <span>轮播图3标题:</span>
                      <el-input type="text" autocomplete="off" v-model="formData.banner3Title" clearable
                        style="width: 7vw;"></el-input>
                    </div>
                    <div class="carousel_item">
                      <span>跳转类型:</span>
                      <el-select v-model="formData.banner3SkipType" style="width:7vw">
                              <el-option label="无跳转" :value="0"/>
                              <el-option label="外部链接" :value="1"/>
                              <el-option label="小程序" :value="2"/>
                            </el-select>
                    </div>
                  </div>
                  <div class="carousel_item">
                    <span>跳转链接:</span>
                    <el-input type="text" autocomplete="off" v-model="formData.banner3SkipUrl" clearable
                      style="width: 20vw;"></el-input>
                  </div>
                  <div class="carousel_item">
                    <span>跳转参数:</span>
                    <el-input type="text" autocomplete="off" v-model="formData.banner3SkipParameter" clearable
                      style="width: 20vw;"></el-input>
                  </div>
                </div>

                <!-- <div style="height: 60px;width: 60px; background-color:aquamarine;"></div> -->
                  <!-- 图片 -->
                  <!-- <el-upload style="display:flex" :class="{hide_box: upload_btn1}"
                                     action="/admin/sys-file/upload"
                                     ref="upload" accept=".jpeg,.jpg,.png" :headers="headers"
                                     :on-remove="handleRemove3" list-type="picture-card" :file-list="picList3"
                                     :on-success="(res,file) => {handleSuccess3(res,file)}"
                                     :on-change="(files, fileList) => {handleChange(files, fileList)}">
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload> -->
                          <photoUpload :photo-url.sync="picList3"/>

              </div>
              <div class="carousel">
                <div>
                  <div style="display: flex;">
                    <div class="carousel_item">
                      <span>轮播图4标题:</span>
                      <el-input type="text" autocomplete="off" v-model="formData.banner4Title" clearable
                        style="width: 7vw;"></el-input>
                    </div>
                    <div class="carousel_item">
                      <span>跳转类型:</span>
                      <el-select v-model="formData.banner4SkipType" style="width:7vw">
                              <el-option label="无跳转" :value="0"/>
                              <el-option label="外部链接" :value="1"/>
                              <el-option label="小程序" :value="2"/>
                            </el-select>
                    </div>
                  </div>
                  <div class="carousel_item">
                    <span>跳转链接:</span>
                    <el-input type="text" autocomplete="off" v-model="formData.banner4SkipUrl" clearable
                      style="width: 20vw;"></el-input>
                  </div>
                  <div class="carousel_item">
                    <span>跳转参数:</span>
                    <el-input type="text" autocomplete="off" v-model="formData.banner4SkipParameter" clearable
                      style="width: 20vw;"></el-input>
                  </div>
                </div>

                <!-- <div style="height: 60px;width: 60px; background-color:aquamarine;"></div> -->
                  <!-- 图片 -->
                  <!-- <el-upload style="display:flex" :class="{hide_box: upload_btn1}"
                                     action="/admin/sys-file/upload"
                                     ref="upload" accept=".jpeg,.jpg,.png" :headers="headers"
                                     :on-remove="handleRemove4" list-type="picture-card" :file-list="picList4"
                                     :on-success="(res,file) => {handleSuccess4(res,file)}"
                                     :on-change="(files, fileList) => {handleChange(files, fileList)}">
                            <i slot="default" class="el-icon-plus"></i>
                          </el-upload> -->
                          <photoUpload :photo-url.sync="picList4"/>

              </div>

            </div>
            </div>
          </div>

        </div>
      </el-form>
      <productCategoryDialog v-if="showProductCategoryDialog" :visiable.sync="showProductCategoryDialog" multi="false"
        @confirm="confirmCategory" />
    </div>
  </div>
</template>
<script>
import {
  initVxeTable
} from '@/const/crud/admin/table';
import Tinymce from '@/components/Tinymce';
import request from "@/router/axios";
import store from "@/store";
import {
  mapGetters
} from "vuex";
import api from "@/api/projectApi";
import {uploadFileFormat} from "@/util/uploadFormat";
// 图片
import photoUpload from "@/components/formItem/photoUpload.vue"
// toolbar标题
const titleConfig = [
  { Choice: '.ql-insertMetric', title: '跳转配置' },
  { Choice: '.ql-bold', title: '加粗' },
  { Choice: '.ql-italic', title: '斜体' },
  { Choice: '.ql-underline', title: '下划线' },
  { Choice: '.ql-header', title: '段落格式' },
  { Choice: '.ql-strike', title: '删除线' },
  { Choice: '.ql-blockquote', title: '块引用' },
  { Choice: '.ql-code', title: '插入代码' },
  { Choice: '.ql-code-block', title: '插入代码段' },
  { Choice: '.ql-font', title: '字体' },
  { Choice: '.ql-size', title: '字体大小' },
  { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
  { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
  { Choice: '.ql-direction', title: '文本方向' },
  { Choice: '.ql-header[value="1"]', title: 'h1' },
  { Choice: '.ql-header[value="2"]', title: 'h2' },
  { Choice: '.ql-align', title: '对齐方式' },
  { Choice: '.ql-color', title: '字体颜色' },
  { Choice: '.ql-background', title: '背景颜色' },
  { Choice: '.ql-image', title: '图像' },
  { Choice: '.ql-video', title: '视频' },
  { Choice: '.ql-upload', title: '文件' },

  { Choice: '.ql-link', title: '添加链接' },
  { Choice: '.ql-formula', title: '插入公式' },
  { Choice: '.ql-clean', title: '清除字体格式' },
  { Choice: '.ql-script[value="sub"]', title: '下标' },
  { Choice: '.ql-script[value="super"]', title: '上标' },
  { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
  { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
  { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
  { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
  { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
  { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
  { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
  { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
  { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
  { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
  { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
  { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
  { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
  { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
  { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="center"]', title: '居中对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="right"]', title: '居右对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="justify"]', title: '两端对齐' }
]
export default {
  inject: ['reload'],
  name: 'parameter',

  props: {
    _dataId: [String, Number]
  },
  components: {
    Tinymce,photoUpload
  },
  computed: {
    api() {
      return api
    },
    ...mapGetters(["permissions"]),
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId ? tenantId : '1'
      };
    }
  },
  data() {
    return {
      upload_btn1: false,
      upload_btn2: false,
      upload_btn3: false,
      upload_btn4: false,
      picList1 : null,
      picList2 : null,
      picList3 : null,
      picList4 : null,
      formData: {
        knowledgeTypeId: null,  // 知识库分类ID,关联bas_knowledge_type.id
        title: null,  // 标题
        keyWords: null,  // 关键字
        isTop: 0,  // 是否置顶:0否1是
        isPublic: 1,  // 是否发布:0否1是
        content: null,  // 内容;注意为富文本
        selectedItemCategoryList: [],
        companyCustNetLimit: 0,//组网上限
        companyEvaluateMaxHours:12,

        privacyPolicy: null,  // 隐私协议
        userPolicy: null,  // 用户协议
        servicePolicy: null,  // 服务条款
        cardPolicy: null,  // 保修卡说明
        serviceNotice: null, //服务须知
        scanTemp: null,  // 扫码示例
        backDates: 0,  // 可申请退保天数
        goodCommentGift:0,//好评赠送延保(月)
        onLineUrl:null,//在线客服跳转地址
        callCenterPhone:null,//400客服
        beyondHoursCreateBenefit: 0,  // 过退保期限后几小时开始分账
        amountGate: 0,  // 审核金额开关
        banner1Title: null,  // 轮播图1标题
        banner1Pic: null,  // 轮播图1
        banner1SkipType: 0,  // 轮播图1跳转类型:0无跳转;1外部链接;2小程序;
        banner1SkipUrl: null,  // 轮播图1跳转链接
        banner1SkipParameter: null,  // 轮播图1跳转参数
        banner2Title: null,  // 轮播图2标题
        banner2Pic: null,  // 轮播图2
        banner2SkipType: 0,  // 轮播图2跳转类型:0无跳转;1外部链接;2小程序;
        banner2SkipUrl: null,  // 轮播图2跳转链接
        banner2SkipParameter: null,  // 轮播图2跳转参数
        banner3Title: null,  // 轮播图3标题
        banner3Pic: null,  // 轮播图3
        banner3SkipType: 0,  // 轮播图3跳转类型:0无跳转;1外部链接;2小程序;
        banner3SkipUrl: null,  // 轮播图3跳转链接
        banner3SkipParameter: null,  // 轮播图3跳转参数
        banner4Title: null,  // 轮播图4标题
        banner4Pic: null,  // 轮播图4
        banner4SkipType: 0,  // 轮播图4跳转类型:0无跳转;1外部链接;2小程序;
        banner4SkipUrl: null,  // 轮播图4跳转链接
        banner4SkipParameter: null,  // 轮播图4跳转参数


      },
      selectedItemCategoryList: [],
      knowledgeTypeOption: [],
      knowledgeTypeIdList: [],
      img_b: "",
      upload_btn: false, // 是否隐藏上传图片按钮
      radio: '1',
      showEdit: false,
      valuetype: 'model',
      textarea: '',
      //  value1: true,
      value2: false,
      value3: true,
      activeName: 'first',
      dialog: {
        one: false,
      },
      lan: 'zh_CN',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      intValueSplit: '',
      // 基本信息
      service: {
        pic: '',
      },
      tenant: {
        status: 0,
        tenantAttachmentDTOs: [],
        projectCode: '',
        projectName: '',
        valueType: 1,
        valueSplit: '',
        usable: 1,
        seq: 0
      },
      showProductCategoryDialog: false,
      editorOption: {
        modules: {
          toolbar: [

            ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
            ["blockquote", "code-block"], // 引用  代码块
            [{ header: 1 }, { header: 2 }], // 1、2 级标题
            [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
            [{ script: "sub" }, { script: "super" }], // 上标/下标
            [{ indent: "-1" }, { indent: "+1" }], // 缩进
            // [{'direction': 'rtl'}],                         // 文本方向
            [{ size: ["small", false, "large", "huge"] }], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
            [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
            [{ font: [] }], // 字体种类
            [{ align: [] }], // 对齐方式
            ["clean"], // 清除文本格式
            ["link", "image", "video", "upload"] // 链接、图片、视频
          ], //工具菜单栏配置
        },
        placeholder: '请在这里添加描述', //提示
        readyOnly: false, //是否只读
        theme: 'snow', //主题 snow/bubble
      }
    };
  },
  computed: {
    // enabled: {}
    editor() {
      return this.$refs.myTextEditor.quillEditor;
    },
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    // console.log(this.tenant,"tenant的值");
  },
  mounted() {
    this.initTitle()
    this.getData()
  },
  watch: {
    picList1: {
      handler(newVal, oldVal) {
        this.formData.banner1Pic = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
    picList2: {
      handler(newVal, oldVal) {
        this.formData.banner2Pic = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
    picList3: {
      handler(newVal, oldVal) {
        this.formData.banner3Pic = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
    picList4: {
      handler(newVal, oldVal) {
        this.formData.banner4Pic = uploadFileFormat(newVal)
      },
      deep: true, // 加这个属性，深度监听
    },
  },
  methods: {
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
        // 上传成功
        handleSuccess1(res, file) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn = true;
      console.log(res.data.url, "url")
      this.picList1 = [
        {url: res.data.url}
      ]
    },

    handleSuccess2(res, file) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn = true;
      console.log(res.data.url, "url")
      this.picList2 = [
        {url: res.data.url}
      ]
    },
    handleSuccess3(res, file) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn = true;
      console.log(res.data.url, "url")
      this.picList3 = [
        {url: res.data.url}
      ]
    },
    handleSuccess4(res, file) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn = true;
      console.log(res.data.url, "url")
      this.picList4 = [
        {url: res.data.url}
      ]
    },
    handleRemove1(response, file, fileList) {
      this.picList1 = []
    },
    handleRemove2(response, file, fileList) {
      this.picList2 = []
    },
    handleRemove3(response, file, fileList) {
      this.picList3 = []
    },
    handleRemove4(response, file, fileList) {
      this.picList4 = []
    },
    echoKnowledgeType() {
      this.$http({
        url: api.basKnowledgeType.echoCascaderDataUrl,
        method: 'post',
        data: { id: this.formData.knowledgeTypeId }
      }).then(res => {
        this.knowledgeTypeIdList = res.data.data
      })
    },
    initTitle() {
      document.getElementsByClassName('ql-editor')[0].dataset.placeholder = ''
      for (let item of titleConfig) {
        let tip = document.querySelector('.quill-editor ' + item.Choice)
        if (!tip) continue
        tip.setAttribute('title', item.title)
      }
    },
    // 失去焦点
    onEditorBlur(editor) {
    },
    // 获得焦点
    onEditorFocus(editor) {
    },
    // 开始
    onEditorReady(editor) {
    },
    // 值发生变化
    onEditorChange(editor) {
      this.content = editor.html;
      console.log(editor);
    },





    getData() {
      this.$http({
        url: api.basCompanyConfig.getDataUrl,
        method: 'post',
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.formData = response.data.data
        console.log('this.formData',response.data.data)
      })
    },
    saveData() {
      console.log("this.formData--->",this.formData)
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()

            var url = (this.formData.id ? api.basCompanyConfig.updateDataUrl : api.basCompanyConfig.saveDataUrl);
            this.$http({
              url: url,
              method: `post`,
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message.success("保存成功！")
              this.reload()
              this.$mask.close()

              // this.$emit('editViewDataUpdate')
            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！")
              this.$mask.close()

            });
          });
        }
      });
    },

  },
};

</script>
<style lang="scss" scoped>
::v-deep .detail-wrap .d-cont {
  height: calc(100vh - 77px) !important
}

// 轮播图图片
.carousel {
  border: 1px solid #ededed;
  width: 49%;
  margin-bottom: 10px;
  display: flex;
  padding-top: 8px;
  justify-content: space-between;

  .carousel_item {
    display: flex;
    margin-bottom: 8px;

    span {
      margin-right: 3px;
      display: inline-block;
      width: 6vw;
      line-height: 28px;
      text-align: right;
      color: #565656;
      font-size: 12px;
    }
  }
}

.editor {
  line-height: normal !important;
  height: 235px;
  // margin-top: 10px;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
  content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: '保存';
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-tooltip[data-mode=upload]::before {
  content: "请输入文件地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  content: '等宽字体';
}

.papers {
  margin-left: 20px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 30px;
  }

}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}
::v-deep .el-upload--picture-card {
  margin: 20px!important;
  width: 60px !important;
  height: 60px !important;
  line-height: 65px !important;
}


.el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 60px !important;
  height: 60px !important;
  margin-right: 0px !important;
  border-radius: 2px;
  padding: 0px !important;
  border-color: #e8e8e8;
  margin-top: 20px;
  margin-bottom: 10px;
  // margin-left: 80%;
}
::v-deep .table-detail.el-upload--picture-card {
    margin: 20px!important;
    // margin-left: 30%;
    width: 60px !important;
    height: 60px !important;
    line-height: 65px !important;

  }

  ::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
    width: 60px !important;
    height: 60px !important;
    padding: 0 !important;
  }

  ::v-deep .el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 60px !important;
    height: 60px !important;
    margin-right: 0px !important;
    border-radius: 2px;
    padding: 0px !important;
    border-color: #e8e8e8;
    margin-top: 20px;
    margin-bottom: 10px;
    // margin-left: 80%;
  }
  .headline{
    margin-bottom: 5px;
  }
</style>
